// extracted by mini-css-extract-plugin
module.exports = {"root":"eDRy7fXB","titleBase":"FY2lFaBF","bodySmall":"iaoiwWUR","horizontalDivider":"mv4rIrdw","sectionRow":"unZY_SRd","competitorsWrapper":"edLaIsUc"};